import React, { useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { WorkHistoryPB, EducationsPB, TrainingsAndCertificatesPB } from '../../Components/pages/profileBuilderTwo';
import styles from './ProfileBuilder.module.scss';
import { restoreAfterRefresh } from '../../actions/uploadData';
import ProfileBuilderWrapper from '../../Components/pages/profileBuilder.Wrapper/ProfileBuilderWrapper';
import ValidationErrorLabel from '../../Components/common/ValidationErrorLabel/ValidationErrorLabel';
import { MOBILE_BREAKPOINT, validationMessages } from '../../utils/constants';
import { useWindowSize } from '../../utils/hooks';

function ProfileBuilderTwo() {
  const dispatch = useDispatch();
  const [t] = useTranslation();
  const size = useWindowSize();
  const allCvUploadStore = useSelector((state) => state.uploadData.parsedCV);
  const validationMessage = useMemo(() => validationMessages(t), [t]);
  const errors = useSelector((state) => state.uploadData.validationErrors);

  const handleRefresh = () => {
    localStorage.setItem('forRestoreStore', JSON.stringify(allCvUploadStore));
  };

  const restoreData = () => {
    const data = localStorage.getItem('forRestoreStore');

    if (data) {
      dispatch(restoreAfterRefresh({ ...JSON.parse(data) }));
      localStorage.setItem('forRestoreStore', '');
    }
  };

  useEffect(() => {
    window.addEventListener('beforeunload', handleRefresh);
    return () => {
      window.removeEventListener('beforeunload', handleRefresh);
    };
  }, [allCvUploadStore?.JobExperienceDetails, allCvUploadStore?.EducationDetails, allCvUploadStore?.TrainingDetails]);

  useEffect(() => {
    restoreData();
  }, []);

  return (
    <ProfileBuilderWrapper
      titleMain={t('profile.builder.start.complete')}
      titleSecondary={t('profile.builder.start.imported')}
      text={t('profile.builder.start.verify')}
      progress={34}
    >
      <div className="row py-4">
        {(!!errors?.JobExperienceDetails?.length ||
          !!errors?.EducationDetails?.length ||
          !!errors?.TrainingDetails?.length) && (
          <ValidationErrorLabel message={validationMessage.PROFILE_BUILDER_TWO_COMMON_ERROR} />
        )}
        <div className="col-12 mt-3">
          <div className={`${styles.outline} ${styles.historyList} text-start`}>
            <WorkHistoryPB />
            <EducationsPB />
            <TrainingsAndCertificatesPB />
          </div>
        </div>
      </div>
      <div className={size.width > MOBILE_BREAKPOINT ? 'row pt-5' : 'd-flex flex-column-reverse'}>
        <div className={size.width > MOBILE_BREAKPOINT ? 'col-6 text-start' : 'col-12 d-flex justify-content-center'}>
          <Link
            to="/dashboard/profile-builder-one"
            className={`outline-button text-decoration-none p-3 px-5 mt-4 ${
              size.width > MOBILE_BREAKPOINT ? '' : 'w-100'
            }`}
            title=""
            data-bs-toggle="tooltip"
          >
            <span className="d-inline text-capitalize">{t('common.general.back')}</span>
          </Link>
        </div>
        <div
          className={
            size.width > MOBILE_BREAKPOINT
              ? 'col-6 text-start d-flex justify-content-end'
              : 'col-12 d-flex justify-content-center'
          }
        >
          {!errors?.JobExperienceDetails?.length &&
          !errors?.EducationDetails?.length &&
          !errors?.TrainingDetails?.length &&
          !errors?.RequireAtLeastOneItem?.length ? (
            <Link
              to="/dashboard/profile-builder-three"
              className={`button p-3 px-5 ${size.width > MOBILE_BREAKPOINT ? 'mt-4' : 'w-100'}`}
              title=""
              data-bs-toggle="tooltip"
            >
              <span className="d-inline text-capitalize">{t('common.general.saveandcontinue')}</span>
            </Link>
          ) : (
            <div
              role="presentation"
              className={`btn btn-secondary p-3 px-5 pe-auto ${styles.nextButton} ${
                size.width > MOBILE_BREAKPOINT ? 'mt-4' : 'w-100'
              }`}
            >
              <span className="d-inline text-capitalize">{t('common.general.saveandcontinue')}</span>
            </div>
          )}
        </div>
      </div>
    </ProfileBuilderWrapper>
  );
}

export default ProfileBuilderTwo;
